<svg viewBox="0 0 24 24">
  <path fill-rule="evenodd"
    d="M5.492 9.054a.95.95 0 000 1.357L12 16.8l6.509-6.389a.951.951 0 00-1.333-1.357L12 14.134l-5.176-5.08a.951.951 0 00-1.332 0z"
    clip-rule="evenodd" />
</svg>